// export this package's api
'use strict';

module.exports = require('./Pagination');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-pagination/lib/index.js
 ** module id = 599
 ** module chunks = 0
 **/